import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import useScreenshotDownload from './hooks/useScreenshotDownload';
import useScreenshotWebShare from './hooks/useScreenshotWebShare';
import DIcon from '../DIcon';
import DButton from '../DButton';
export default function DVoucher({ amount, amountDetails, icon, title, onError, message, downloadText = 'Download', shareText = 'Share', className, children, }) {
    const { shareRef, share } = useScreenshotWebShare();
    const { downloadRef, download } = useScreenshotDownload();
    const handleShare = () => {
        share()
            .catch(async (err) => {
            if (onError) {
                await onError(err);
            }
        })
            .catch(() => {
            // Error already handled by onError
        });
    };
    const handleDownload = () => {
        download()
            .catch(async (err) => {
            if (onError) {
                await onError(err);
            }
        })
            .catch(() => {
            // Error already handled by onError
        });
    };
    const defaultIconProps = {
        icon: 'CircleCheckBig',
        color: 'success',
        size: '2rem',
        hasCircle: true,
    };
    const resolvedIconProps = (() => {
        if (icon === false || icon == null)
            return null;
        if (typeof icon === 'string')
            return Object.assign(Object.assign({}, defaultIconProps), { icon });
        if (typeof icon === 'object')
            return Object.assign(Object.assign({}, defaultIconProps), icon);
        return defaultIconProps;
    })();
    return (_jsx("div", { className: classNames('d-voucher', className), ref: (el) => {
            shareRef.current = el;
            downloadRef.current = el;
        }, children: _jsxs("div", { children: [_jsxs("div", { className: "d-voucher-header", children: [resolvedIconProps && (_jsx(DIcon, Object.assign({}, resolvedIconProps))), _jsxs("div", { className: "text-center", children: [_jsx("h3", { className: "mb-2", children: title }), _jsx("p", { className: "m-0", children: message })] })] }), amount && (_jsxs("div", { className: "d-voucher-amount", children: [_jsx("div", { className: classNames('text-center fw-bold fs-3', amountDetails ? 'mb-1' : 'm-0'), children: amount }), amountDetails] })), _jsx("hr", { className: "my-4" }), children, _jsx("hr", { className: "my-4" }), _jsxs("div", { className: "d-voucher-footer", children: [_jsx(DButton, { onClick: handleShare, iconStart: "Share2", text: shareText, variant: "outline", size: "sm" }), _jsx(DButton, { onClick: handleDownload, iconStart: "Download", text: downloadText, variant: "outline", size: "sm" })] })] }) }));
}
//# sourceMappingURL=DVoucher.js.map